import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { ResumeIcon } from '~/modules/common/components/Icons';
import { InnerAttachmentsBlock } from '~/modules/attachments/AttachmentsBlock/AttachmentsBlock';
import { CUSTOM_METADATA_BUILDER } from '~/modules/attachments/uploader/attachmentUtil';
import DelaAttachmentStatus from '~/modules/attachments/AttachmentsBlock/AttachmentsList/DelaAttachmentStatus';
import useResumeHandlers from './useResumeHandlers';
import UploadResumeButton from './UploadResumeButton';

export const title = <FormattedMessage id="resumeCard.resume" />;

export const avatarIcon = <ResumeIcon />;

export const acceptedFileTypes = [
  '.txt',
  '.pdf',
  '.doc',
  '.docx',
  '.odt',
  '.rtf'
];

const ResumeCard = ({ userUri, editable }) => {
  const {
    resume,
    isDialogOpen,
    onDialogOpen,
    onDialogClose,
    onFileUpload,
    isUploading,
    isLoading,
    error,
    deleteResume,
    enabledSourceUris
  } = useResumeHandlers({
    userUri,
    customMetadataFn: CUSTOM_METADATA_BUILDER.RESOURCE
  });

  return (
    <InnerAttachmentsBlock
      attachments={resume ? [resume] : []}
      onDialogOpen={onDialogOpen}
      onDialogClose={onDialogClose}
      isDialogOpen={isDialogOpen}
      attachToUri={userUri}
      deleteAttachment={deleteResume}
      editable={editable}
      onDialogOK={onFileUpload}
      error={error}
      isUploading={isUploading}
      isLoading={isLoading}
      enabledSourceUris={enabledSourceUris}
      title={title}
      AvatarIcon={avatarIcon}
      multiple={false}
      NewAttachmentButtonComponent={UploadResumeButton}
      acceptedFileTypes={acceptedFileTypes}
      fileTypeErrorMessageId="resumeCard.invalidFileTypeError"
      AttachmentStatusComponent={DelaAttachmentStatus}
      showDelaStarIcon
    />
  );
};

ResumeCard.propTypes = {
  userUri: PropTypes.string.isRequired,
  editable: PropTypes.bool.isRequired
};

export default memo(ResumeCard);
